import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50beb5ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Calcular Preços", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xl-20 ant-col-xs-24" }
const _hoisted_7 = { class: "ant-col ant-col-xl-4 ant-col-xs-24" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xl-24 ant-col-xs-24 ss-div-grupos" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-18" }, null, -1))
const _hoisted_14 = { class: "ant-col ant-col-xl-6 ant-col-xs-24" }
const _hoisted_15 = {
  class: "ant-row",
  style: {"overflow-x":"scroll","max-width":"100%"}
}
const _hoisted_16 = {
  class: "ant-row",
  style: {"min-width":"1400px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-row ss-grade-personalizada-titulo",
  style: {"width":"100%"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Tabela de Preço")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Custo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "C. Adicional")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Incidências")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Markup")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Preço Antigo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-alinhar-texto-direita" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Preço Novo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" })
], -1))
const _hoisted_18 = { class: "ant-col ant-col-xl-6" }
const _hoisted_19 = { class: "ss-margin-campos" }
const _hoisted_20 = { class: "ant-col ant-col-xl-5" }
const _hoisted_21 = { class: "ss-margin-campos" }
const _hoisted_22 = { class: "ant-col ant-col-xl-2" }
const _hoisted_23 = { class: "ss-margin-campos" }
const _hoisted_24 = { class: "ant-col ant-col-xl-2" }
const _hoisted_25 = { class: "ss-margin-campos" }
const _hoisted_26 = { class: "ant-col ant-col-xl-2" }
const _hoisted_27 = { class: "ss-margin-campos" }
const _hoisted_28 = { class: "ant-col ant-col-xl-2" }
const _hoisted_29 = { class: "ss-margin-campos" }
const _hoisted_30 = { class: "ant-col ant-col-xl-2" }
const _hoisted_31 = { class: "ss-margin-campos" }
const _hoisted_32 = { class: "ant-col ant-col-xl-2" }
const _hoisted_33 = { class: "ss-margin-campos" }
const _hoisted_34 = {
  class: "ant-col ant-col-xl-1",
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_formacao_preco = _resolveComponent("selecionar-formacao-preco")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_item_tabela_preco_produto = _resolveComponent("selecionar-item-tabela-preco-produto")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_buscar_produtos_modal = _resolveComponent("buscar-produtos-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 1000,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode("Aplicar Formação de Preço")
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-secondary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.calcularPrecos && _ctx.calcularPrecos(...args)))
          }, _hoisted_2),
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmarAtualizacao && _ctx.confirmarAtualizacao(...args)))
          }, _hoisted_4)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_card, { titulo: "Formação de Preço" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_a_form_item, {
                          label: "Formação Utilizada",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_formacao_preco, {
                              empresas: [_ctx.storeSistema.getters.codigoEmpresaOperacao()],
                              codigoSelecionado: _ctx.state.formacaoPrecoSelecionada,
                              "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.formacaoPrecoSelecionada) = $event)),
                              onChange: _ctx.obterFormacaoPreco
                            }, null, 8, ["empresas", "codigoSelecionado", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_form_item, {
                          label: "Margem de Lucro",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              valor: _ctx.state.formacaoPreco.margemLucro,
                              "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.formacaoPreco.margemLucro) = $event)),
                              percentual: true,
                              disabled: true
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (_ctx.state.formacaoPrecoSelecionada > 0)
                      ? (_openBlock(), _createBlock(_component_card, {
                          key: 0,
                          titulo: "Grupos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.formacaoPreco.grupos, (grupo, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "ss-div-grupo",
                                    key: index
                                  }, [
                                    _createVNode(_component_card, {
                                      class: "ss-card-grupo",
                                      titulo: grupo.descricao
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_table, {
                                          columns: _ctx.state.colunasGrupos.filter(item => item.visible),
                                          "data-source": grupo.itens,
                                          rowKey: "codigo",
                                          pagination: false,
                                          scroll: { y: 200 },
                                          size: "small",
                                          rowClassName: "ss-table-campos"
                                        }, {
                                          emptyText: _withCtx(() => [
                                            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
                                          ]),
                                          bodyCell: _withCtx(({ column, text, }) => [
                                            (column.key === 'valor')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(grupo.tipoValor === 1 ? _ctx.UtilitarioMascara.mascararValor(text, 2) + '%' : 'R$ ' + _ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(text), 1))
                                          ]),
                                          _: 2
                                        }, 1032, ["columns", "data-source"])
                                      ]),
                                      _: 2
                                    }, 1032, ["titulo"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.state.formacaoPrecoSelecionada > 0)
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 0,
                      titulo: "Produtos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                              class: "ant-btn ant-btn-secondary",
                              style: {"width":"100%","margin-bottom":"5px"},
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.abrirBuscaProdutos && _ctx.abrirBuscaProdutos(...args)))
                            }, "Adicionar Produto")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            (!_ctx.UtilitarioGeral.validaLista(_ctx.state.alteracoes) || _ctx.state.alteracoes.length <= 0)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  style: {"width":"100%"},
                                  mensagem: "Nenhum produto adicionado ainda."
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.UtilitarioGeral.validaLista(_ctx.state.alteracoes) && _ctx.state.alteracoes.length > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.alteracoes, (alteracao, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "ant-row ss-grade-personalizada-linha",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_component_selecionar_produto, {
                                          empresas: [_ctx.storeSistema.getters.codigoEmpresaOperacao()],
                                          "modo-definicao-produto": true,
                                          "codigo-selecionado": _ctx.state.alteracoes[index].codigoProdutoDefinicao,
                                          "onUpdate:codigoSelecionado": [($event: any) => ((_ctx.state.alteracoes[index].codigoProdutoDefinicao) = $event), ($event: any) => (_ctx.atualizarProduto(index))]
                                        }, null, 8, ["empresas", "codigo-selecionado", "onUpdate:codigoSelecionado"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_selecionar_item_tabela_preco_produto, {
                                          empresas: [_ctx.storeSistema.getters.codigoEmpresaOperacao()],
                                          "codigo-produto-definicao": _ctx.state.alteracoes[index].codigoProdutoDefinicao,
                                          "codigo-item-selecionado": _ctx.state.alteracoes[index].codigoTabelaPrecoItemProduto,
                                          "onUpdate:codigoItemSelecionado": [($event: any) => ((_ctx.state.alteracoes[index].codigoTabelaPrecoItemProduto) = $event), ($event: any) => (_ctx.obterCustoProduto(index))]
                                        }, null, 8, ["empresas", "codigo-produto-definicao", "codigo-item-selecionado", "onUpdate:codigoItemSelecionado"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: true,
                                          valor: _ctx.state.alteracoes[index].custo,
                                          "onUpdate:valor": ($event: any) => ((_ctx.state.alteracoes[index].custo) = $event),
                                          disabled: true
                                        }, null, 8, ["valor", "onUpdate:valor"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: true,
                                          valor: _ctx.state.alteracoes[index].custoAdicional,
                                          "onUpdate:valor": ($event: any) => ((_ctx.state.alteracoes[index].custoAdicional) = $event)
                                        }, null, 8, ["valor", "onUpdate:valor"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_campo_numerico, {
                                          percentual: true,
                                          valor: _ctx.state.alteracoes[index].incidencias,
                                          "onUpdate:valor": ($event: any) => ((_ctx.state.alteracoes[index].incidencias) = $event)
                                        }, null, 8, ["valor", "onUpdate:valor"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_campo_numerico, {
                                          percentual: true,
                                          valor: _ctx.state.alteracoes[index].markup,
                                          "onUpdate:valor": ($event: any) => ((_ctx.state.alteracoes[index].markup) = $event),
                                          disabled: true
                                        }, null, 8, ["valor", "onUpdate:valor"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: true,
                                          valor: _ctx.state.alteracoes[index].precoAnterior,
                                          "onUpdate:valor": ($event: any) => ((_ctx.state.alteracoes[index].precoAnterior) = $event),
                                          disabled: true
                                        }, null, 8, ["valor", "onUpdate:valor"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: true,
                                          valor: _ctx.state.alteracoes[index].precoNovo,
                                          "onUpdate:valor": ($event: any) => ((_ctx.state.alteracoes[index].precoNovo) = $event)
                                        }, null, 8, ["valor", "onUpdate:valor"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("a", null, [
                                        _createVNode(_component_icone, {
                                          nome: "excluir",
                                          onClick: ($event: any) => (_ctx.excluirAlteracao(index))
                                        }, null, 8, ["onClick"])
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_buscar_produtos_modal, {
          titulo: "Buscar Produtos",
          visivel: _ctx.state.exibirBusca,
          "onUpdate:visivel": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.exibirBusca) = $event)),
          empresas: [_ctx.storeSistema.getters.codigoEmpresaOperacao()],
          parametrosConsultaDefinicao: _ctx.state.parmetrosConsulta,
          onConfirmadoSelecaoProdutos: _ctx.inserirAlteracoes
        }, null, 8, ["visivel", "empresas", "parametrosConsultaDefinicao", "onConfirmadoSelecaoProdutos"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}